import endpoints from 'constants/endpoints';
import {
  GET_FAQS,
  GET_CARRIER_FAQS,
  SET_CARRIER_FAQS_LOADER,
  CLEAR_CARRIER_FAQS,
  SET_FAQS_BY_CARRIER
} from 'constants/types';
import { safePostCall } from 'helpers/firebaseSetup';
import { questionFactory } from 'helpers/factory/questionFactory';

export const getFAQsData =
  (setLocalLoader = () => {}, cancelTokenSource = {}) =>
  async dispatch => {
    setLocalLoader(true);
    safePostCall(
      endpoints.awsProxy.safePost,
      {
        endpoint: endpoints.zoho.getFAQS,
        isZohoRequest: true
      },
      { cancelToken: cancelTokenSource.token }
    )
      .then(faqsRes => {
        if (faqsRes) {
          const response = faqsRes.data.details.output;
          const faqsArray = JSON.parse(response).faqsArray;
          const transformedResponse = faqsArray.map(item => ({
            id: item.id,
            type: item.type,
            questions: item.questions.map(question => questionFactory(question))
          }));

          setLocalLoader(false);
          dispatch({
            type: GET_FAQS,
            payload: transformedResponse
          });
        } else {
          setLocalLoader(false);
          console.error('Unexpected response structure', faqsRes);
        }
      })
      .catch(error => {
        console.error(error);
        if (!(error?.message === 'API Call Canceled')) {
          setLocalLoader(false);
        }
      });
  };

export const getCarrierFaqs =
  (carrierId = '', cancelTokenSource = {}) =>
  async dispatch => {
    dispatch({
      type: CLEAR_CARRIER_FAQS,
      payload: true
    });
    dispatch({
      type: SET_CARRIER_FAQS_LOADER,
      payload: true
    });
    safePostCall(
      endpoints.awsProxy.safePost,
      {
        carrierId,
        endpoint: endpoints.zoho.getCarrierFAQS,
        isZohoRequest: true
      },
      { cancelToken: cancelTokenSource.token }
    )
      .then(res => {
        if (res) {
          const response = res.data.details.output;
          const faqsArray = JSON.parse(response).carrierFaqs;
          let carrierFaqsFormatted = faqsArray.map(question =>
            questionFactory(question)
          );
          dispatch({
            type: GET_CARRIER_FAQS,
            payload: carrierFaqsFormatted
          });
          dispatch({
            type: SET_CARRIER_FAQS_LOADER,
            payload: false
          });
        } else {
          dispatch({
            type: SET_CARRIER_FAQS_LOADER,
            payload: false
          });
          // Handle the case where the response structure is unexpected
          console.error('Unexpected response structure', res);
        }
      })
      .catch(error => {
        console.error(error);
        if (!(error?.message === 'API Call Canceled')) {
          dispatch({
            type: SET_CARRIER_FAQS_LOADER,
            payload: false
          });
        }
      });
  };

export const getCarrierFAQs =
  (carrierId = '', carrierName = '', cancelTokenSource = {}) =>
  async (dispatch, getState) => {
    dispatch({
      type: SET_CARRIER_FAQS_LOADER,
      payload: true
    });

    safePostCall(
      endpoints.awsProxy.safePost,
      {
        carrierId,
        endpoint: endpoints.zoho.getCarrierFAQS,
        isZohoRequest: true
      },
      { cancelToken: cancelTokenSource.token }
    )
      .then(res => {
        if (res?.data?.details?.output) {
          const faqsByCarrier = getState().faqs.faqsByCarrier;
          const response = res.data.details.output;
          const faqs = JSON.parse(response).carrierFaqs;
          const formattedFaqs = faqs.map(question => questionFactory(question));
          faqsByCarrier[carrierName] = formattedFaqs;
          dispatch({
            type: SET_FAQS_BY_CARRIER,
            payload: faqsByCarrier
          });
        }
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        dispatch({
          type: SET_CARRIER_FAQS_LOADER,
          payload: false
        });
      });
  };
